import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-testid": "schedule-overlap-alert",
  class: "flex flex-col gap-3 rounded-lg border border-alert bg-alert/10 p-3 text-left"
}
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  "data-testid": "schedule-overlap-alert-badge",
  class: "rounded bg-alert px-2 py-[2px] text-[11px] font-bold uppercase leading-4 tracking-wide text-white"
}, " Requer atenção ", -1)
const _hoisted_4 = { class: "text-sm leading-[18px] text-textPrimary" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Conflito de agenda:", -1)
const _hoisted_6 = {
  key: 0,
  class: "text-sm leading-[18px] text-textPrimary"
}
const _hoisted_7 = {
  key: 1,
  "data-testid": "schedule-overlap-alert-date",
  class: "text-sm font-bold leading-[18px] text-textPrimary"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-[18px] text-textPrimary" }, " Nada foi bloqueado. Revise a agenda do médico se a sobreposição não for intencional. ", -1)

import { computed } from 'vue'
import { format, parseISO } from 'date-fns'
import AlertCircle from '@/assets/icons/mdiAlertCircle.vue'
import type { Alert } from '@/Network/Types/Responses/StationResponses'

/** Espelha o token `alert` do tailwind.config.js (paleta de aviso do design system). */
const ALERT_TOKEN_HEX = '#F18F1B'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleOverlapAlert',
  props: {
    alerts: {},
    mode: { default: 'create' }
  },
  setup(__props: any) {

const props = __props;



const headline = computed(() =>
  props.mode === 'update'
    ? 'A edição foi salva, mas o médico já está alocado em outro plantão neste horário.'
    : 'A vaga foi criada, mas o médico já está alocado em outro plantão neste horário.'
)

function formatAlertDate(alert: Alert): string {
  const value = alert.dateTime
  if (!value) return ''
  const parsed = typeof value === 'string' ? parseISO(value) : value
  if (!(parsed instanceof Date) || Number.isNaN(parsed.getTime())) return ''
  return `Plantão em conflito: ${format(parsed, 'dd/MM/yyyy')}`
}

return (_ctx: any,_cache: any) => {
  return (_ctx.alerts.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(AlertCircle, {
            color: ALERT_TOKEN_HEX,
            width: "18",
            height: "18",
            class: "shrink-0"
          }),
          _hoisted_3
        ]),
        _createElementVNode("p", _hoisted_4, [
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(headline.value), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            "data-testid": "schedule-overlap-alert-item",
            class: "flex flex-col gap-1"
          }, [
            (alert.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(alert.description), 1))
              : _createCommentVNode("", true),
            (formatAlertDate(alert))
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(formatAlertDate(alert)), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _hoisted_8
      ]))
    : _createCommentVNode("", true)
}
}

})